import { useState, useEffect } from 'react';
import orderApi from '_api/order';
import { BUYER_ORDER_UNPAID } from '_utils/constant';

const orderStatusCache = new Map();

export default function useHasOrder(eid) {
  const [hasOrder, setHasOrder] = useState(() => Boolean(eid && orderStatusCache.get(eid)));

  useEffect(() => {
    let isMounted = true;
    if (eid) {
      if (orderStatusCache.has(eid)) {
        setHasOrder(orderStatusCache.get(eid));
      }
      orderApi
        .getListOrdersByEventId(eid)
        .then(({ msgResp }) => {
          if (Array.isArray(msgResp)) {
            const hasExistingOrder = msgResp.some(
              (order) => order.buyerStatus >= BUYER_ORDER_UNPAID
            );
            orderStatusCache.set(eid, hasExistingOrder);
            if (isMounted) {
              setHasOrder(hasExistingOrder);
            }
          }
        })
        .catch((err) => {
          if (isMounted) {
            console.error('Error fetching event orders:', err);
          }
        });
    } else {
      setHasOrder(false);
    }

    return () => {
      isMounted = false;
    };
  }, [eid]);

  return hasOrder;
}
